import React from 'react';
import './ContactForm.css';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Switch from '@material-ui/core/Switch';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import {Link} from "react-router-dom";

const ContactForm = props => {
    const fieldStyle = {
        "margin":"15px 0"
    };
    const selectStyle={
        "width":"45%",
        "margin":"15px 0"
    };
    // document.getElementsByName("body")[0].style.backgroundImage = "url(\"./../../Assets/formbg.svg\")";
    return (
        <div id="contact-page">
            <div id="contact-form">
                <Link to="/">
                    <div id="home">
                        <i className="fas fa-home"/>
                        Back to home
                    </div>
                </Link>
                <span className="form-title">Free Trail Form</span>
                <span className="form-footer">Copyrights &copy; Audigo Global Solutions Pvt Ltd; 2019-2021</span>
                <TextField style={fieldStyle} fullWidth label="Full Name" variant="outlined" />
                <TextField style={fieldStyle} fullWidth label="Email Address" variant="outlined" />
                <TextField style={fieldStyle} fullWidth label="Phone Number" variant="outlined" />
                <div style={{"display":"flex","justifyContent":"space-between"}}>
                    <FormControl style={selectStyle} variant="outlined" className="">
                        <InputLabel id="demo-simple-select-outlined-label">Service</InputLabel>
                        <Select label="Service">
                            <option aria-label="None" value="" />
                            <option value="Finance & Accounting">Finance & Accounting</option>
                            <option value="Business Support Services">Business Support Services</option>
                            <option value="Due Diligence">Due Diligence</option>
                            <option value="Tax Advisory">Tax Advisory</option>
                            <option value="People Management">People Management</option>
                            <option value="Software Services">Software Services</option>
                        </Select>
                    </FormControl>

                    <FormControl style={selectStyle} variant="outlined" className="">
                        <InputLabel id="demo-simple-select-outlined-label">Sub-service Type</InputLabel>
                        <Select label="Sub-service Type">
                            <option aria-label="None" value="" />
                            <option value={10}>Ten</option>
                            <option value={20}>Twenty</option>
                            <option value={30}>Thirty</option>
                        </Select>
                    </FormControl>

                </div>

                <FormControlLabel
                    control={<Switch />}
                    label="Subscribe for our newsletters & updates about products & services"
                />
                <div style={{"display":"flex", "justifyContent":"flex-end", "marginTop":"15px"}}>
                    <Button variant="contained" color="primary" disableElevation>
                        Submit Request
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ContactForm;


// WEBPACK FOOTER //
// ./src/Components/ContactForm/ContactForm.js